import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Cursor1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.2501 21C17.0508 21.0012 16.8592 20.9229 16.7176 20.7825L12.1201 16.1775L9.62263 19.9275C9.46012 20.1764 9.16594 20.3059 8.87263 20.2575C8.58562 20.2148 8.34902 20.0103 8.26513 19.7325L3.76513 4.73254C3.65587 4.45812 3.71785 4.14513 3.92345 3.93306C4.12904 3.72099 4.43996 3.64934 4.71763 3.75004L19.7176 8.25004C19.9954 8.33392 20.1999 8.57053 20.2426 8.85754C20.291 9.15084 20.1615 9.44503 19.9126 9.60754L16.1626 12.105L20.7676 16.7025C20.9096 16.8434 20.9895 17.0351 20.9895 17.235C20.9895 17.435 20.9096 17.6267 20.7676 17.7675L17.7676 20.7675C17.6322 20.9098 17.4464 20.9933 17.2501 21ZM17.2501 19.1925L19.1926 17.25L13.8226 11.8875L17.7601 9.26251L5.61762 5.61751L9.26262 17.76L11.8876 13.8225L17.2501 19.1925Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Cursor1.vue"]]);
